import { v4 as uuidv4 } from 'uuid'
import useCookies from '~/composables/useCookies'

const COOKIE_NAME = 'vook.session_id'
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 90

export default () => {
  const $cookies = useCookies()

  const getSessionId = () => $cookies.get<string>(COOKIE_NAME)

  const getOrCreateSessionId = () => {
    const existing = getSessionId()
    if (existing) {
      return existing
    }

    const sessionId = uuidv4()
    $cookies.set(COOKIE_NAME, sessionId, {
      domain: process.env.COOKIE_DOMAIN,
      path: '/',
      maxAge: COOKIE_MAX_AGE_SECONDS
    })
    return sessionId
  }

  return { getSessionId, getOrCreateSessionId }
}
